// @flow

import styled from '@ncigdc/theme/styled';

export default styled.th({
  backgroundColor: '#dedddd',
  padding: '3px',
  lineHeight: '20px',
  textAlign: 'left',
  whiteSpace: 'nowrap',
});



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/uikit/Table/Th.js